export default {
    orders: [],
    totalOrders: 0,
    paramsSearch: {
        status: null,
        'guest-name': '',
        'shift-number': '',
        operator: '',
        num: '',
        price_min: '',
        price_max: '',
        dep_id: null,
        'order-date': null,
        'brand': null,
    },
    openOrders: null,
    paramsSearchForCalling: {
        status: null,
        'guest-name': '',
        'shift-number': '',
        operator_id: null,
        num: '',
        price_min: '',
        price_max: '',
        dep_id: null,
        'order-date': null,
    },
}
